import { Link } from "react-router-dom";
import NFTCard from "../../components/NFTCard";
import useNftInfo from "../../hooks/useNftInfo";

function NFTList() {
  const { accountNftInfo, nftInfo } = useNftInfo();
  console.log(accountNftInfo);
  return (
    <div className="w-full mt-[130px] mb-[122px] px-3">
      {accountNftInfo.tokenIds.length ? (
        <div className="max-w-[1362px] w-full mx-auto rounded-[11px] bg-[#F7F7F7] p-[22px_10px_22px_24px] flex sm:justify-between justify-evenly flex-wrap max-h-[1200px] overflow-y-scroll scrollbar-grey min-h-[300px]">
          {accountNftInfo.tokenIds.map((data, i) => {
            return (
              <NFTCard
                tokenId={data}
                price={nftInfo.mintPrice / Math.pow(10, 6)}
                key={i}
                logo={`https://maverickbl.mypinata.cloud/ipfs/QmWv2LJVeEQcf4MPaA6azNSs3TvY3NifeXq6VkDRF4bZ2m/${data}.png`}
              />
            );
          })}
        </div>
      ) : (
        <div className="text-primary flex justify-center items-center flex-col w-full">
          <NFTCard
            tokenId={1}
            price={nftInfo.mintPrice / Math.pow(10, 6)}
            size={"450px"}
            type={"info"}
            logo={`https://maverickbl.mypinata.cloud/ipfs/QmWv2LJVeEQcf4MPaA6azNSs3TvY3NifeXq6VkDRF4bZ2m/1.png`}
          />
          <div className="mt-5 text-center sm:text-[40px] text-2xl font-semibold ">
            <div className="mb-5">No NFTs Owned</div>
            <Link className="underline text-secondary" to={"/mintnft"}>
              Buy NFTs
            </Link>
          </div>
        </div>
      )}
    </div>
  );
}

export default NFTList;
